import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  migrationId: string;
  procedureId?: string;
}

interface Result {
  saved: Boolean;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/migration/save_procedure',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};
export const useSaveMigrationItemProcedure = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSaveMigrationItemProcedureLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveMigrationItemProcedure;
